import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services';

// ═══════════════════════════════════════════════════════════════════════════
// ZONAS DE ENTREGA
// ═══════════════════════════════════════════════════════════════════════════

export const getZonasPanel = async (searchTerm, page, perPage, suc_id) => {
  let queryParams = [];
  if (searchTerm) {
    queryParams.push(`nombre=${encodeURIComponent(searchTerm)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  if (suc_id) {
    queryParams.push(`suc_id=${encodeURIComponent(suc_id)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/zonasentrega", queryString);
};

export const getZonasSelect = async (suc_id) => {
  const queryString = suc_id ? `?suc_id=${suc_id}` : '';
  return await getData("/zonasentrega/select", queryString);
};

export const getZonaById = async (id) => {
  return await getData(`/zonasentrega/${id}`);
};

export const getZonasPorUbicacion = async (latitud, longitud) => {
  return await getData(`/zonasentrega/por-ubicacion?latitud=${latitud}&longitud=${longitud}`);
};

export const postZona = async (body) => {
  return await postData('/zonasentrega', body);
};

export const patchZona = async (id, body) => {
  return await patchData(`/zonasentrega/${id}`, body);
};

export const deleteZona = async (id) => {
  return await deleteData(`/zonasentrega/${id}`);
};
